import { FailedCheckKeys, VehicleChecks } from "../types/apis";
import { FormData, FormResources } from "../types/formData";
import { checkForOption } from "./checkForOption";

const checkQualifications = (values: FormData): string => {
  let details = "";
  if (values.log_book === "1") {
    details += "The customer does not have the v5c.\n";
  }
  if (values.was_taxi === "1") {
    details += "The vehicle has been used as a taxi.\n";
  }
  if (values.speedo_change === "1") {
    details += "The vehicle has a documented odometer change.\n";
  }
  if (values.left_handed === "1") {
    details += "The vehicle is left handed drive.\n";
  }
  if (details.length > 0) {
    details = "The vehicle has issues from qualification:\n" + details;
  }
  return details;
};

const checkModifications = (values: FormData): string => {
  let details = "";
  if (values.modifications === "yes") {
    details += "The vehicle has been modified:\n";
    details += values.modifcationDetails!;
  }
  return details;
};

const checkMechanical = (values: FormData, formResources: FormResources): string => {
  let details = "";
  const isNoSelected = checkForOption(values.faults, "no");
  if (!isNoSelected && values.faults && values.faults.length > 0) {
    details += "The vehicle has mechanical or electrical faults:\n";
    details += values.faults.reduce((accumulator: string, currentValue: string) => {
      return (
        accumulator +
        formResources.mechanics.options.find(
          (fault) => fault.value === currentValue,
        )!.label +
        "\n"
      );
    }, "");
    // Replace 'other' with the text area
    details = details.replace(
      formResources.mechanics.options[5].label,
      values.known_faults!,
    );
  }

  return details;
};

export const checkProvenanceChecks = (checks: VehicleChecks): string => {
  let details = "";
  if (!checks.passed) {
    const checksToEscalate = checks.checks.reduce<string[]>((acc, check) => {
      if (check.key !== FailedCheckKeys.INSURANCE_WRITE_OFF) {
        acc.push(check.value);
      }
      return acc;
    }, []);
    if (checksToEscalate.length) {
      details += "Vehicle history needs to be checked manually:\n";
      details += checksToEscalate.reduce(
        (accumulator, currentValue) => accumulator + currentValue + ".\n",
        "",
      );
    }
  }
  return details;
};

export const checkForEscalations = (
  values: FormData,
  formResources: FormResources,
  checks: VehicleChecks,
): string => {
  const qualificationDetails = checkQualifications(values);
  const modificationDetails = checkModifications(values);
  const mechanicalDetails = checkMechanical(values, formResources);
  const provenanceChecksDetails = checkProvenanceChecks(checks);

  return (
    qualificationDetails +
    modificationDetails +
    mechanicalDetails +
    provenanceChecksDetails
  );
};
